/* eslint-disable @typescript-eslint/unbound-method */
import { Injectable } from '@angular/core'
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { AccountInfo } from '@se-po/shared-data-access-models'
import { PhoneParser } from '@se-po/shared-data-access-parsers'
import { CustomValidators } from '@se-po/shared-data-access-validators'

@Injectable({
  providedIn: 'root'
})
export class AccountInfoFormCreateService {

  private form: UntypedFormGroup

  constructor(private fb: FormBuilder) { }

  public get value(): AccountInfo {
    return this.form?.value as AccountInfo
  }

  public createForm(): UntypedFormGroup {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      dateOfBirth: ['', [
        Validators.required,
        CustomValidators.dobValid,
        CustomValidators.dob13,
      ]],
      canadian: [],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, CustomValidators.phone10To12]],
      thirdPartyMailing: []
    })
    this.init()
    return this.form
  }

  private init(): void {
    this.initPhoneFormatter()
    this.initDobFormatter()
    this.initCanadianValidation()
  }

  private initPhoneFormatter(): void {
    this.form.get('phone').valueChanges
      .subscribe((phoneVal: string) => {
        const formattedPhone = PhoneParser.format10(phoneVal)
        if (formattedPhone !== phoneVal) {
          this.form.patchValue({ phone: formattedPhone })
        }
      })
  }

  private initDobFormatter(): void {
    this.form.get('dateOfBirth').valueChanges
      .subscribe((dobVal: string) => {
        let fmt = (dobVal || '').replace(/\/\//g, '/')
        const trailingSlash = fmt.charAt(fmt.length - 1) === '/'
        // eslint-disable-next-line prefer-const
        let [m, d, y] = fmt.split('/')
        if ((y || trailingSlash) && d && d.length < 2) {
          const dnum = parseInt(d, 10)
          if (dnum < 10) d = `0${dnum}`
        }
        if ((d || trailingSlash) && m && m.length < 2) {
          const mnum = parseInt(m, 10)
          if (mnum < 10) m = `0${mnum}`
        }

        if (m && d && (y || trailingSlash)) {
          fmt = `${m}/${d}/${y || ''}`
        }
        else if (m && (d || trailingSlash)) {
          fmt = `${m}/${d || ''}`
          if (d.length === 2) fmt += '/'
        }
        else if (m) {
          fmt = m
          if (m.length === 2) fmt += '/'
        }

        if (fmt !== dobVal) {
          this.form.patchValue({ dateOfBirth: fmt })
        }
      })
  }

  private initCanadianValidation(): void {
    this.form.get('canadian').valueChanges
      .subscribe((canadianVal: string) => {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const validators = canadianVal ? [Validators.required] : []
        this.form.get('thirdPartyMailing').setValidators(validators)
        this.form.get('thirdPartyMailing').updateValueAndValidity()
      })
  }
}
